import { css } from '@emotion/core'
import { measures } from 'styles/variables'

const { half, unit } = measures

export const wrapperLabel = css`
  margin-top: ${half}px;
  margin-right: ${half}px;
`
export const inWinnableRowWrapper = css`
  padding-top: ${unit}px;
`
